import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { DeleteForever } from '@mui/icons-material';

const ToSchemeForm = ({
    handleChallanFormData, 
    schemeLoading, 
    screenType,
    toSubheadData,
    fy_list,
    handleToSubheadChange,
    toSchemes,
    fromSchemeDetails,
    to_subheadsList,
    totalToAmount,
    handleToActivityChange,
    activity,
    findSubActivitiesById,
    addNewActivity,
    deleteNewActivity
}) => {
    const { authData } = useSelector((state) => state.authData);
    return (
        <>
            <div className='col-md-12'>
                <h5>To Scheme</h5>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label for="inputFinancial" className="col-form-label"> Financial Year <span className="text-danger">*</span> :</label>
                    <select className="form-control " id="financial_year"
                        name='to_financial_id'
                        value={toSubheadData.to_financial_id}
                        onChange={handleToSubheadChange}
                        disabled={schemeLoading || screenType == "View" || screenType == "Edit"}
                        required
                    >
                        <option value="">---select year---</option>
                        {
                            fy_list.map((fy) => {
                                return (
                                    <option value={fy.id}
                                        key={fy.id}>{fy.year}</option>
                                );
                            })
                        }
                    </select>
                    
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label for="to_scheme_id" className="col-form-label">Scheme <span className="text-danger">*</span></label>
                    <select className="form-control "
                        id="to_scheme_id" name='to_scheme_id'
                        required
                        value={toSubheadData.to_scheme_id}
                        onChange={handleToSubheadChange}
                    >
                        <option>Select Scheme</option>
                        {
                            toSchemes.map((schemes) => {
                                return (
                                    schemes.l2_status == 1 && schemes.l3_status == 1 &&
                                    <option value={schemes.id}
                                        key={schemes.id}>{schemes.code}</option>
                                );
                            })
                        }
                    </select>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Scheme Name</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.to_scheme_name} disabled />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Department Name</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.to_department_name} disabled />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Grant Code</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.to_grant_code} disabled />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Type of Scheme</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.to_scheme_type} disabled />
                </div>
            </div>
            <div className='col-md-12 mt-3'>
                <h5>To Subhead</h5>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label for="inputFinancial" className="col-form-label"> Subhead <span className="text-danger">*</span> :</label>
                    <select className="form-control " id="financial_year"
                        name='to_subhead_id'
                        value={toSubheadData.to_subhead_id}
                        onChange={handleToSubheadChange}
                        required>
                        <option value="">---Select Subhead---</option>
                        {
                            to_subheadsList.map((subhead) => {
                                return (
                                    <option
                                        value={subhead.id}
                                        key={subhead.id}>{subhead.code}</option>
                                );
                            })
                        }
                    </select>
                </div>
            </div>

            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Subhead Name</label>
                    <input type="text" className="form-control" value={toSubheadData.subhead_name} readOnly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Subhead Balance</label>
                    <input type="text" className="form-control" value={toSubheadData.subhead_balance} readonly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Reappropriation Amount</label>
                    {fromSchemeDetails.to_is_activity_active == 1 && <input type="text"
                        className="form-control"
                        name="to_reappropriation_amount"
                        value={totalToAmount.current}
                        readOnly
                    />}
                    {fromSchemeDetails.to_is_activity_active == 0 && <input type="text"
                        className="form-control"
                        name="to_reappropriation_amount"
                        value={toSubheadData.to_reappropriation_amount}
                        onChange={handleChallanFormData}
                    />}
                </div>
            </div>
            {fromSchemeDetails.to_is_activity_active == '1' && ((fromSchemeDetails.to_monitoring_level == "3" && authData.user.department_details.department_level != 'T1') || (fromSchemeDetails.to_monitoring_level != "3")) && <div className="col-md-12" style={{ marginTop: '20px' }}>
                <table className="table table-bordered" style={{ tableLayout: 'auto' }}>
                    <thead className="text-center-custom">
                        <tr>
                            <th scope="col" width="150px">Activity</th>
                            <th scope="col" width="150px">Subactivity</th>
                            <th scope="col" width="300px">Available Balance</th>
                            <th scope="col" width="300px">Amount</th>
                            <th scope="col" width="150px">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-center-custom">
                        {toSubheadData?.activity.map((activityData, index) => (
                            <tr key={index}>
                                <td>
                                    <select
                                        className="form-control"
                                        name='activity_id'
                                        value={activityData.activity_id}
                                        onChange={(e) => handleToActivityChange(index, e)}
                                        disabled={!toSubheadData.to_subhead_id}>
                                        <option value="">---Select---</option>
                                        {activity.map(activity => {
                                            // console.log("subheadActivity.length", subheadActivity.current);
                                            if (toSubheadData?.activity_budget && toSubheadData?.activity_budget.length) {
                                                const exists = toSubheadData?.activity_budget.find(e => e.subhead_activity_id == activity.id);

                                                if (exists) {
                                                    return (
                                                        <option key={activity.id} value={activity.id}>{activity.activity}</option>
                                                    )
                                                }
                                            }
                                            else {
                                                if (fromSchemeDetails.to_monitoring_level == "2") {
                                                    return (
                                                        <option key={activity.id} value={activity.id}>{activity.activity}</option>
                                                    )
                                                }
                                            }
                                        })}
                                    </select>
                                </td>
                                <td>
                                    <select
                                        className="form-control"
                                        name='subactivity_id'
                                        value={activityData.subactivity_id}
                                        onChange={(e) => handleToActivityChange(index, e, activityData.activity_id)}
                                        disabled={!toSubheadData.to_subhead_id}>
                                        <option value="">---Select---</option>
                                        {findSubActivitiesById(activityData.activity_id).map(e => {
                                            if (toSubheadData?.activity_budget && toSubheadData?.activity_budget.length) {
                                                const exists = toSubheadData?.activity_budget.find(item => item.subhead_subactivity_id == e.id);
                                                if (exists) {
                                                    return (
                                                        <option key={e.id} value={e.id}>{e.subactivity}</option>
                                                    )
                                                }
                                            }
                                            else {
                                                if (fromSchemeDetails.monitoring_level == "2") {
                                                    return (
                                                        <option key={e.id} value={e.id}>{e.subactivity}</option>
                                                    )
                                                }
                                            }
                                        }
                                            //<option key={e.id} value={e.id}>{e.subactivity}</option>
                                        )}
                                    </select>
                                </td>
                                <td>{toSubheadData?.activity_budget && toSubheadData?.activity_budget.length != 0 && toSubheadData?.activity_budget.find(e =>
                                    e.subhead_activity_id === activityData.activity_id &&
                                    e.subhead_subactivity_id === activityData.subactivity_id
                                )?.budget}</td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name='budget'
                                        placeholder="Enter Release Budget"
                                        value={activityData?.budget}
                                        disabled={!toSubheadData.to_subhead_id}
                                        onChange={(e) => handleToActivityChange(index, e)}
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-primary mx-2" onClick={(e) => addNewActivity('to')}>
                                        <AddIcon />
                                    </button>
                                    {index != 0 && <button type="button"
                                        className="btn btn-danger mx-2"
                                        onClick={(e) => deleteNewActivity(index, 'to')}>
                                        <DeleteForever /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}
        </>
    );
}

export default ToSchemeForm;